export const MOBILE = /^(\+98|0)?9\d{9}$/